<el-main class="main">
  <div class="form">
    <div class="module module-header">
      <h1 class="header-form">Оформление экспедиторской расписки перед отправкой</h1>
    </div>
    <el-form class="module" label-position="top" ref="ruleFormRef" :model="ruleForm" :rules="rules">
      <el-tabs v-model="formTabs.activeName" class="demo-tabs">
        <el-tab-pane label="Данные контрагентов" name="cargo-transportation-customer">
          <div class="tab-container">
            <SenderPartial @click-button-back="clickFormButtonBack" />
            <ConsigneePartial />
            <ThirdPersonPartial @click-button-back="clickFormButtonBack" @click-button-next="clickFormButtonNext" />
          </div>
        </el-tab-pane>
        <el-tab-pane label="Детали перевозки" name="transportation-details">
          <TransportationDetailsPartial @click-button-back="clickFormButtonBack" @click-button-next="clickFormButtonNext" />
        </el-tab-pane>
        <el-tab-pane label="Оплата" name="payment">
          <ForwardingPaymentPartial @click-button-back="clickFormButtonBack" @submit-form-sender="submitFormSender" :ruleFormRef="ruleFormRef" />
        </el-tab-pane>
      </el-tabs>
      <el-dialog v-model="alertOfApplicationSubmission.isVisiblePrint" title="Уважаемый клиент!" class="dialog" center>
        <div class="print-container">
          <span class="span_padding-bottom--8px"
            >Вами сформирована<br />
            экспедиторская расписка</span
          >
          <span class="span_padding-bottom--8px"><strong>№{{ alertOfApplicationSubmission.numberApplication }}</strong></span>
          <span class="span_padding-bottom--8px"
            >От {{ alertOfApplicationSubmission.createTime.day }}/{{ parseDate(Number(alertOfApplicationSubmission.createTime.month) + 1) }}/{{ alertOfApplicationSubmission.createTime.year }}</span
          >

          <span
            >Продиктуйте последние 7 цифр<br />
            на приёмке склада при сдаче груза</span
          >
        </div>
        <template #footer>
          <div class="button_container">
            <el-button class="button__send" @click="onPrint" type="primary" :icon="Printer">Печать экспедиторской расписки</el-button>
            <el-button class="button__send" @click="onMarkingCardPrint" type="primary" :icon="Printer">Печать маркировочных талонов</el-button>
            <el-button @click="closePrintingModal" type="primary">Закрыть</el-button>
          </div>
        </template>
      </el-dialog>
    </el-form>
  </div>
</el-main>
